import { main } from "./main";

main(window, customElements);
